import React, { useEffect } from 'react';

import { Section } from 'craft/containers/Toolbox/components';
import { useShadowCss } from 'craft/containers/Toolbox/sections/Shadow/useShadowCss';
import { ToolboxComponentSchema } from 'craft/types';

import { ShadowProperty } from './ShadowProperty';

interface ShadowProps {
  nodeIds: string[];
  schema: ToolboxComponentSchema['Shadow'];
}

export type ShadowProperties = 'offsetX' | 'offsetY' | 'blur' | 'spread' | 'color';

export const Shadow: React.FC<ShadowProps> = ({ nodeIds, schema }: ShadowProps) => {
  const { cssSelectorId, isFilter } = schema;
  const { css, hasShadow, toggleShadow } = useShadowCss(nodeIds, cssSelectorId, isFilter);

  useEffect(() => {
    // if shadow was previously toggled on but no values were set, reset it
    if (
      css.filter === 'drop-shadow(0px 0px 0px #D2D6DB)' ||
      css.boxShadow === '0px 0px 0px 0px #D2D6DB'
    ) {
      toggleShadow();
    }
  }, [nodeIds]);

  return (
    <Section name="Shadow" isExpanded={hasShadow} onToggle={toggleShadow}>
      <ShadowProperty nodeIds={nodeIds} property="color" isInGroup schema={schema} />
      <ShadowProperty
        nodeIds={nodeIds}
        property="offsetX"
        label="Offset X"
        isInGroup
        schema={schema}
      />
      <ShadowProperty
        nodeIds={nodeIds}
        property="offsetY"
        label="Offset Y"
        isInGroup
        schema={schema}
      />
      <ShadowProperty
        nodeIds={nodeIds}
        property="blur"
        label="Blur"
        isInGroup={{ isLast: isFilter }}
        schema={schema}
      />
      {!isFilter && (
        <ShadowProperty
          nodeIds={nodeIds}
          property="spread"
          label="Spread"
          isInGroup={{ isLast: true }}
          schema={schema}
        />
      )}
    </Section>
  );
};
